import { render } from "./AppIconXjh.vue?vue&type=template&id=6e322517&scoped=true"
import script from "./AppIconXjh.vue?vue&type=script&lang=js"
export * from "./AppIconXjh.vue?vue&type=script&lang=js"

import "./AppIconXjh.vue?vue&type=style&index=0&id=6e322517&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e322517"]])

export default __exports__